export enum EnumDistributorSectionCard {
  scope = 'scope', // cakupan
  distributor_detail = 'distributor_detail', // detail distributor
  owner = 'owner', // pemilik usaha
  manager = 'manager', // pengelola usaha
  business_information = 'business_information', // informasi usaha
  npwp_information = 'npwp_information', // informasi npwp
  supplier_information = 'supplier_information', // informasi supplier
  // delivery_address = 'delivery_address', // alamat pengiriman
  business_branch = 'business_branch', // cabang usaha
  credit_ceiling_granted = 'credit_ceiling_granted', // plafon kredit
  sale_target = 'sale_target',
  credit_billing = 'credit_billing',
  information_receivable = 'information_receivable',
  document_non_active = 'document_non_active',
}

export enum EnumDeliveryAddressCard {
  label = 'label',
  pic_name = 'pic_name',
  pic_phone = 'pic_phone',
  regency_name = 'regency_name',
  district_name = 'district_name',
  sub_district_name = 'sub_district_name',
  full_address = 'full_address',
  latitude = 'latitude',
  longitude = 'longitude',
}
